import { css } from "lit";

export default css`
    .enemy {
        display: block;
        position: absolute;
        width: 100px;
        height: 100px;
        background-repeat: no-repeat;
        background-size: contain;
    }
`;